import { UnorderedList } from 'components/lists';
import { FormattedUnitValue } from 'components/text';
import { useGlobalConfigsContext } from 'contexts';
import { usePII } from 'features/pii';
import { FeatureIconName } from 'libs/icons';
import { useTranslation } from 'libs/translations';
import { IUserProfile, IUserStructureAutoshipsData } from 'types';
import { formatNumberLocalized } from 'utils';

import { WidgetAutoshipsDetails } from './WidgetAutoshipsDetails';
import { Widget } from '../Widget';

interface IWidgetStructureAutoshipsProps extends IUserStructureAutoshipsData {
  readonly userProfile: IUserProfile;
}

export function WidgetStructureAutoships(
  props: IWidgetStructureAutoshipsProps
) {
  const { t, activeLanguage } = useTranslation();
  const { pii } = usePII();
  const {
    app: {
      office: { enableDecimals }
    }
  } = useGlobalConfigsContext();

  return (
    <Widget
      traceId="Structure Autoships"
      title={t('Structure Autoships')}
      detailedViewButtonLabel={t('History')}
      iconName={FeatureIconName.Autoships}
      content={
        <div className="grid grid-cols-1 gap-sm">
          <UnorderedList
            items={[
              {
                content: t('Firstline'),
                rightNode: pii(
                  formatNumberLocalized(
                    activeLanguage,
                    props.autoshipsInFirstline.current ?? 0,
                    false,
                    enableDecimals
                  ),
                  'number'
                )
              },
              {
                content: t('Structure'),
                rightNode: pii(
                  formatNumberLocalized(
                    activeLanguage,
                    props.autoshipsInStructure.current ?? 0,
                    false,
                    enableDecimals
                  ),
                  'number'
                )
              },
              {
                content: t('Open Volume'),
                rightNode: props.autoshipsOpenTurnover && (
                  <FormattedUnitValue
                    value={props.autoshipsOpenTurnover}
                    unit="points"
                  />
                )
              }
            ]}
          />
        </div>
      }
      detailedView={
        <WidgetAutoshipsDetails
          autoshipsInFirstline={props.autoshipsInFirstline}
          autoshipsInStructure={props.autoshipsInStructure}
          gainedAutoshipsInStructure={props.gainedAutoshipsInStructure}
          lostAutoshipsInStructure={props.lostAutoshipsInStructure}
        />
      }
    />
  );
}
